//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';

import Button from '@material-ui/core/Button';
//Material-ui


//Icon
import EmailIcon from '@material-ui/icons/Email';


class Comp extends React.Component {
  componentDidMount() {
    document.title = 'メールアドレスの認証 - パートナーズ';
    window.scrollTo(0, 0);
    if (this.props.my.request.datetime && !this.props.my.request.email) {
      this.props.history.push('/new/end/');
    }
  }

  render() {
    let email = this.props.my.request.email;
    let link;

    if (email) {
      if(email.match(/(@gmail\.com)/)) {
        link = (<a href='https://mail.google.com/' target='_blank' rel="noopener noreferrer"><u>GMAILへ</u></a>);
      }
      else if(email.match(/(@yahoo\.co\.jp)/)) {
        link = (<a href='https://jp.mg5.mail.yahoo.co.jp/' target='_blank' rel="noopener noreferrer"><u>Yahooメールへ</u></a>);
      }
      else if(email.match(/(@outlook\.jp)|(@outlook\.com)|(@hotmail\.com)|(@live\.jp)/)) {
        link = (<a href='https://login.live.com/' target='_blank' rel="noopener noreferrer"><u>Liveメールへ</u></a>);
      }
      else if(email.match(/(@excite\.co\.jp)/)) {
        link = (<a href='http://email.excite.co.jp/' target='_blank' rel="noopener noreferrer"><u>Exciteメールへ</u></a>);
      }
      else if(email.match(/(@aol\.com)/)) {
        link = (<a href='https://mail.aol.jp/' target='_blank' rel="noopener noreferrer"><u>AOLメールへ</u></a>);
      }
      else if(email.match(/@[a-zA-Z0-9]+\.ocn\.ne\.jp/)) {
        link = (<a href='https://mail.ocn.ne.jp/' target='_blank' rel="noopener noreferrer"><u>OCNメールへ</u></a>);
      }
    }

    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>

        <h1 align='center'>
          <span className='i-b'>メールアドレスの登録を</span>
          <span className='i-b'>完了してください</span>
        </h1>
        <div  align='center'>
          <EmailIcon style={{fontSize:'6em',color:'#999'}} />
        </div>
        <div>
          <h3 align='center' style={{padding:'10px'}}>
            下記のメールアドレスに<br />
            確認メールを送信しました<br />
            本文に記載された認証コードを<br />
            クリックしてください
          </h3>
        </div>

        <div>
          <h3 align='center' style={{padding:'10px'}}>
            {email} {link}
          </h3>
        </div>

        <br />
        <div align='right' style={{padding:'15px'}}>
          <Button
            variant="outlined"
            onClick={ () => this.props.history.push('/new/end/') }
          >
            今は認証しない
          </Button>
        </div>
      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
